import React, { useContext, createContext, useState } from 'react'
import { node } from 'prop-types';
import { useCookies } from 'react-cookie';

const TutorialContext = createContext({})

export function useTutorialContext() {
  return useContext(TutorialContext)
}

function TutorialProvider({ children }) {
  const [cookie, setCookie, removeCookie] = useCookies(['tutorial']);
  const currentUserEmail = cookie['currentUserEmail'] || undefined

  const addUser = email => {
    setCurrentUserEmailIntoCookie(email)
    if (!cookie['tutorial']) {
      setCookie('tutorial', [{ userEmail: email }], { path: '/', sameSite: 'strict' });
    }
    else {
      const index = cookie['tutorial'].findIndex(e => e.userEmail == email)
      if (index == -1) {
        setCookie('tutorial', [...cookie['tutorial'], { userEmail: email }], { path: '/', sameSite: 'strict' });

      }
    }
  }

  const getUserIndex = email => {
    return cookie['tutorial'].findIndex(e => e.userEmail == email)
  }

  const getTutorialBox = index => {
    if (cookie['tutorial']) {
      const query = cookie['tutorial'][index]
      const { tutorialBox } = query
      return tutorialBox
    }
  }

  const getTutorialStep1 = index => {
    if (cookie['tutorial']) {
      const query = cookie['tutorial'][index]
      const { tutorialStep1 } = query
      return tutorialStep1
    }
  }

  const getTutorialStep2 = index => {
    if (cookie['tutorial']) {
      const query = cookie['tutorial'][index]
      const { tutorialStep2 } = query
      return tutorialStep2
    }
  }

  const getTutorialStep3 = index => {
    if (cookie['tutorial']) {
      const query = cookie['tutorial'][index]
      const { tutorialStep3 } = query
      return tutorialStep3
    }
  }

  const getAllTutorial = email => {
    try {
      const index = cookie['tutorial'].findIndex(e => e.userEmail == email)
      if (index >= 0)
        return {
          tutorialBox: getTutorialBox(index),
          tutorialStep1: getTutorialStep1(index),
          tutorialStep2: getTutorialStep2(index),
          tutorialStep3: getTutorialStep3(index),
          currentUserEmail
        }
      else
        return undefined
    }
    catch (err) {
      return undefined
    }

  }

  const setCurrentUserEmailIntoCookie = (email) => {
    setCookie('currentUserEmail', email, { path: '/', sameSite: 'strict' })
  }

  const setTutorialCookie = (data) => {
    setCookie('tutorial', data, { path: '/', sameSite: 'strict' });
  }

  const setTutorialBox = async data => {
    const index = getUserIndex(currentUserEmail)
    const { tutorialBox, ...other } = cookie['tutorial'][index]
    const tutorialCookie = cookie['tutorial']
    tutorialCookie[index] = { tutorialBox: data, ...other }
    setTutorialCookie(tutorialCookie)
  }

  const setTutorialStep1 = data => {
    const index = getUserIndex(currentUserEmail)
    const { tutorialStep1, ...other } = cookie['tutorial'][index]
    const tutorialCookie = cookie['tutorial']
    tutorialCookie[index] = { tutorialStep1: data, ...other }
    setTutorialCookie(tutorialCookie)
  }

  const setTutorialStep2 = async data => {
    const index = getUserIndex(currentUserEmail)
    const { tutorialStep2, ...other } = cookie['tutorial'][index]
    const tutorialCookie = cookie['tutorial']
    tutorialCookie[index] = { tutorialStep2: data, ...other }
    setTutorialCookie(tutorialCookie)
  }

  const setTutorialStep3 = async data => {
    const index = getUserIndex(currentUserEmail)
    const { tutorialStep3, ...other } = cookie['tutorial'][index]
    const tutorialCookie = cookie['tutorial']
    tutorialCookie[index] = { tutorialStep3: data, ...other }
    setTutorialCookie(tutorialCookie)
  }

  const value = {
    addUser, currentUserEmail,
    setTutorialBox, setTutorialStep1, setTutorialStep2, setTutorialStep3,
    getAllTutorial, getTutorialBox, getTutorialStep1, getTutorialStep2, getTutorialStep3
  }

  return (
    <TutorialContext.Provider value={value}>
      {children}
    </TutorialContext.Provider>
  )
}

TutorialProvider.propTypes = {
  children: node.isRequired
}

export default TutorialProvider
